import { render, staticRenderFns } from "./AthleteAccordionSettings.vue?vue&type=template&id=4c443b76&scoped=true&"
import script from "./AthleteAccordionSettings.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccordionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c443b76",
  null
  
)

export default component.exports